// eslint-disable-next-line
export function getServers(state) {
    return state
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/servers/selectors.js